export default "__VITE_ASSET__bi4CUz7V__"